import { useState, useEffect, useRef } from 'react';
import { Search } from 'lucide-react';

const SearchInput = ({ value, onChange, placeholder = 'Search...', debounce = 300 }) => {
  const [local, setLocal] = useState(value);
  const timerRef = useRef(null);

  useEffect(() => { setLocal(value); }, [value]);

  const handleChange = (e) => {
    const v = e.target.value;
    setLocal(v);
    clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => onChange(v), debounce);
  };

  useEffect(() => () => clearTimeout(timerRef.current), []);

  return (
    <div className="relative">
      <Search className="w-4 h-4 text-pw-hint absolute left-3.5 top-1/2 -translate-y-1/2" />
      <input type="text" value={local} onChange={handleChange} placeholder={placeholder}
        className="input-field pl-10" />
    </div>
  );
};

export default SearchInput;
